import { Link } from "react-router";
import { $path } from "safe-routes";
import { match } from "ts-pattern";

import { PythonLogo } from "~/components/icons/PythonLogo";
import { RLogo } from "~/components/icons/RLogo";
import { tw } from "~/lib/tailwindMixins";
import { cn } from "~/lib/utils";
import { getThumbnailUrl } from "~/routes/notebooks/notebookId/helpers";
import type { Notebook } from "~/schema/db/public/Notebook";
import NotebookSourceCodeLanguage from "~/schema/db/public/NotebookSourceCodeLanguage";

export const TemplateCard = ({
  notebook,
  onSubmit,
  navigateTo,
  navigateInNewTab = false,
}: {
  notebook: Notebook;
  onSubmit?: () => void;
  navigateTo?: string;
  navigateInNewTab?: boolean;
}) => {
  const languageIcon = match(notebook.sourceCodeLanguage)
    .with(NotebookSourceCodeLanguage.r, () => <RLogo height={16} width={16} />)
    .with(NotebookSourceCodeLanguage.python, () => <PythonLogo height={16} width={16} />)
    .exhaustive();

  const path = navigateTo ?? $path("/notebooks/:notebookId", { notebookId: notebook.id });

  return (
    <Link
      to={path}
      reloadDocument
      onClick={() => onSubmit?.()}
      className={cn(
        tw.newCardBorder,
        "cursor-pointer text-left max-w-[228px] bg-card text-foreground hover:bg-card-hover",
      )}
      target={navigateInNewTab ? "_blank" : undefined}
    >
      <span className="flex flex-col w-full">
        <span className="bg-white rounded-t-lg flex justify-center items-center w-full h-[270px] border-b relative">
          <img
            src={getThumbnailUrl(notebook.templateSlug)}
            alt={notebook.name}
            className="w-full h-full object-cover pt-2"
          />
          <span className="bg-muted border rounded-sm absolute left-[10px] top-[-14px] p-1">
            {languageIcon}
          </span>
        </span>
        <span className="w-full p-4 rounded-b-lg">
          <h3>{notebook.name}</h3>
          <p className="text-sm text-muted-foreground">{notebook.description}</p>
        </span>
      </span>
    </Link>
  );
};
